import {basePath} from "./utils/basePath";
import normalizeUrl from "normalize-url";

export type AuthSetup = KeyCloakAuthSetup | AzureAuthSetup;


export interface KeyCloakAuthSetup {
    providerType: "keycloak";
    useLogin: boolean;
    requireAccessControl: boolean;
    providerConfig: {
        "auth": {
            "serverUrl": string;
            "realm": string;
            "clientId": string;
            "redirectUri": string;
            "postLogoutRedirectUri": string;
            navigateToLoginRequestUrl: boolean;
        }
        "cache": {
            cacheLocation: string;
            storeAuthStateInCookie: boolean;
        }
    }
    loginRequest: {
        scopes: Array<string>;
    };
    tokenRequest: {
        scopes: Array<string>;
    };

}

export interface AzureAuthSetup {
    providerType: "azure";
    useLogin: boolean;
    requireAccessControl: boolean;
    providerConfig: {
        auth: {
            clientId: string;
            authority: string;
            knownAuthorities: string[];
            redirectUri: string;
            postLogoutRedirectUri: string;
            navigateToLoginRequestUrl: boolean;
        };
        cache: {
            cacheLocation: string; // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
            storeAuthStateInCookie: boolean; // Set this to "true" if you are having issues on IE11 or Edge
        };
    };
    loginRequest: {
        scopes: Array<string>;
    };
    tokenRequest: {
        scopes: Array<string>;
    };
}

export let isAccessedWithinTeams = false;
export function setIsAccessedWithinTeams(value: boolean) {
    isAccessedWithinTeams = value;
}

export const getRedirectUri = (authSetup: AuthSetup) => {
    return normalizeUrl(authSetup.providerConfig.auth.redirectUri
        .replace('${base_path}', basePath)
        .replace('${host}', window.location.host)
        .replace('${protocol}', window.location.protocol));
};

